__turbopack_context__.v({
  "animatedDetailsWrapper": "ManageStorage-module__g3h8PW__animatedDetailsWrapper",
  "container": "ManageStorage-module__g3h8PW__container",
  "currentStorageWrapper": "ManageStorage-module__g3h8PW__currentStorageWrapper",
  "details": "ManageStorage-module__g3h8PW__details",
  "iconButton": "ManageStorage-module__g3h8PW__iconButton",
  "includedStorageWrapper": "ManageStorage-module__g3h8PW__includedStorageWrapper",
  "wrapper": "ManageStorage-module__g3h8PW__wrapper",
});
